var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.windowResize.width > 650)?_c('SearchLicenses'):_c('RotateScreen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }